export const THEME = 'THEME'
export const THEME_RESET = 'THEME_RESET'
export const THEME_IMAGE_CHANGE = 'THEME_IMAGE_CHANGE'
export const THEME_IMAGE_FILE = 'THEME_IMAGE_FILE'
export const THEME_STATUS = 'THEME_STATUS'
export const SET_THEME_COLORS = 'SET_THEME_COLORS'